import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, Search, ShieldAlert, Utensils, ListTodo } from 'lucide-react';
export function Problem() {
  const bullets = [{
    icon: Search,
    text: 'Buscaste recetas en internet y encontraste información contradictoria.'
  }, {
    icon: ShieldAlert,
    text: 'Le diste algo casero a tu perro y después te preocupaste si estuvo bien.'
  }, {
    icon: AlertCircle,
    text: 'No sabes exactamente qué alimentos son peligrosos para perros.'
  }, {
    icon: Utensils,
    text: 'Quieres darle variedad pero no sabes por dónde empezar.'
  }, {
    icon: ListTodo,
    text: 'Te gustaría tener todo claro y organizado en un solo lugar.'
  }];
  return <section className="py-20 px-4 bg-white" data-id="element-148">
      <div className="max-w-4xl mx-auto" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-150">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-6" data-id="element-151">
            Si tienes un perro y quieres cocinarle en casa, probablemente te has
            sentido así...
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-152">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="space-y-6 text-lg text-gray-700" data-id="element-153">
            <p className="font-medium text-brand-navy text-xl" data-id="element-154">
              Quieres darle algo mejor a tu perro.
            </p>
            <p data-id="element-155">
              Quieres que coma bien, que se vea saludable, que disfrute su
              comida.
            </p>
            <p data-id="element-156">
              Pero cada vez que intentas preparar algo casero, aparece la misma
              duda:
            </p>
            <blockquote className="border-l-4 border-brand-orange pl-4 italic font-semibold text-xl text-brand-navy my-6" data-id="element-157">
              "¿Esto le hará daño?"
            </blockquote>
            <ul className="space-y-3" data-id="element-158">
              <li className="flex items-start gap-2" data-id="element-159">
                <span className="text-brand-orange font-bold mt-1" data-id="element-160">×</span>
                No sabes qué ingredientes son seguros.
              </li>
              <li className="flex items-start gap-2" data-id="element-161">
                <span className="text-brand-orange font-bold mt-1" data-id="element-162">×</span>
                No sabes qué combinaciones funcionan.
              </li>
              <li className="flex items-start gap-2" data-id="element-163">
                <span className="text-brand-orange font-bold mt-1" data-id="element-164">×</span>
                No sabes cuánto darle ni cómo introducir algo nuevo.
              </li>
            </ul>
            <p className="font-medium text-brand-navy" data-id="element-165">
              Y al final terminas dándole lo de siempre porque no quieres
              arriesgarte.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="bg-brand-beige/30 rounded-3xl p-8 border border-brand-beige" data-id="element-166">
            <h3 className="text-xl font-bold text-brand-navy mb-6 text-center" data-id="element-167">
              ¿Te ha pasado alguna de estas cosas?
            </h3>
            <div className="space-y-4" data-id="element-168">
              {bullets.map((bullet, index) => <div key={index} className="flex items-start gap-4 bg-white p-4 rounded-xl shadow-sm" data-id="element-169">
                  <div className="bg-brand-orange/10 p-2 rounded-lg shrink-0" data-id="element-170">
                    <bullet.icon className="w-5 h-5 text-brand-orange" data-id="element-171" />
                  </div>
                  <p className="text-gray-700 text-sm md:text-base" data-id="element-172">
                    {bullet.text}
                  </p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}